export const LoginActionResponse = {
    LoginAndRedirect: 1,
    OptInDenied: 2,
    ShowOnlyOptIn: 3,
    ShowOptInAndDataReplacement: 4,
    DataOverwriteProcessNotCompleted : 5,
    DataOverwriteProcessNotCompletedWithError : 6,
};